import { DataChart } from '../components/ChartWrapper'

export const statesByRegion = {
  centroOeste: ['BR-DF', 'BR-GO', 'BR-MT', 'BR-MS'],
  nordeste: [
    'BR-AL',
    'BR-BA',
    'BR-CE',
    'BR-MA',
    'BR-PB',
    'BR-PE',
    'BR-PI',
    'BR-RN',
    'BR-SE'
  ],
  norte: ['BR-AC', 'BR-AP', 'BR-AM', 'BR-PA', 'BR-RO', 'BR-RR', 'BR-TO'],
  sudeste: ['BR-ES', 'BR-MG', 'BR-RJ', 'BR-SP'],
  sul: ['BR-PR', 'BR-RS', 'BR-SC']
}

export type RegionsKeys = keyof typeof statesByRegion | 'nacional'

export const mapRegionsToRegionsIds: Record<string, RegionsKeys> = {
  'Centro-Oeste': 'centroOeste',
  Nordeste: 'nordeste',
  Norte: 'norte',
  Sudeste: 'sudeste',
  Sul: 'sul',
  Nacional: 'nacional'
}

export const getTransformedMapData = (data: DataChart): DataChart => {
  return data?.map((item) => {
    const region = Object.keys(mapRegionsToRegionsIds).includes(item[0])
      ? mapRegionsToRegionsIds[item[0]]
      : item[0]
    return [region, item[1], item[2]]
  })
}

export const getRegionsMapFormattedId = ({
  id,
  defaultTranslatedLabels,
  chartCustomization
}: {
  id: string
  chartCustomization?: Record<RegionsKeys, string>
  defaultTranslatedLabels: Record<RegionsKeys, string>
}) => {
  const mapCustomization: Record<RegionsKeys, string> =
    chartCustomization || defaultTranslatedLabels

  return Object.keys(mapCustomization).includes(id)
    ? mapCustomization[id as RegionsKeys]
    : id
}
